import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import SendToEmailFormConfig from "./form";
import { useEffect, useState } from "react";
import { SendDocumentDataType } from "@/formTypes/SendDocumentDataType";
import { getHtmlFromRoute, sendPdfToGenerateApi } from "@utils/htmlExport";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";
import { useAppSelector } from "@/store/hooks";
import { getTenantId } from "@utils/Auth";
import { safeEncodeBase64 } from "@utils/Utils";
import { EASYPOS_DOCUMENTS_EMAIL } from "@utils/Constants";

export type EmailProps = {
  emailFilename: string,
  emailSubject: string,
  emailBody: string,
  emailTo?: string,
  Suscription: {
    email: string
  }
}

type SendToEmailFormProps = {
  onSendForm: (data: SendDocumentDataType) => void,
  defaultData: SendDocumentDataType,
  innerForm?: boolean,
  showIncludeImages?: boolean,
  sourceURL: string,
  emailProps: EmailProps,
  filepath?: string
}

const SendToEmailForm = (props: SendToEmailFormProps) => {
  const { onSendForm, innerForm = false, defaultData,
    showIncludeImages = false, sourceURL, emailProps, filepath } = props;
  const [formConfig, setFormConfig] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tenantId, setTenantId] = useState<string>("");
  const suscriptionData = useAppSelector(state => state.suscription.suscription);

  useEffect(() => {
    loadFormConfig();
    loadTenantData();
  }, [])

  const loadTenantData = async () => {
    const tenantId = await getTenantId()
    setTenantId(tenantId)
  }

  const onSubmit = async (formData: SendDocumentDataType) => {
    setIsLoading(true);
    try {
      const html = await getHtmlFromRoute(sourceURL);

      await generateAndSendPDF(html, formData)
      showAlert("success", "El Documento ha sido enviado correctamente")

      if (onSendForm) {
        onSendForm(formData)
      }
    } catch (err) {
      if (err instanceof Error) {
        const errorMessage = err.message || "No fue posible enviar el correo electronico";
        showAlert("danger", errorMessage)
      }
    } finally {
      setIsLoading(false);
    }
  }

  const generateAndSendPDF = async (html: string, formData: SendDocumentDataType) => {
    const useEasyposEmail = suscriptionData?.use_easypos_email || false;
    const requestEmailProps: EmailProps = {
      ...emailProps,
      emailTo: `${formData.emails}`,
      Suscription: {
        ...emailProps.Suscription,
        email: useEasyposEmail ? EASYPOS_DOCUMENTS_EMAIL : emailProps.Suscription.email
      }
    }
    const currentTime = Date.now();
    const targetFile = filepath || `${tenantId}/pdfs/generated/${currentTime}.pdf`;
    const pdfResponse = await sendPdfToGenerateApi(html, targetFile, requestEmailProps)

    if (!pdfResponse.ok) throw new Error("Error generando PDF");
  }

  const loadFormConfig = () => {
    if (showIncludeImages) {
      const includeImages = SendToEmailFormConfig.sections.
        flatMap(s => s.fields)
        .flat()
        .find(f => f.name === "includeImages")
      if (includeImages) {
        includeImages.visibilityHiddenIf = () => false // make the field visible
      }
    }
    setFormConfig(SendToEmailFormConfig)
  }

  return (
    <>
      <DynamicForm<SendDocumentDataType>
        externalFormState={defaultData}
        innerForm={innerForm}
        formConfig={formConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
      <LoadingScreen isLoading={isLoading} />
    </>

  )
}

export default SendToEmailForm;